/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { memo, useMemo } from 'react'
import { Box } from '@mui/material'
import { Viewer, ViewerProps } from '@react-pdf-viewer/core'
import { DefaultLayoutPluginProps, defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

interface DefaultLayoutProps {
  enable: boolean
  sidebarTabs?: DefaultLayoutPluginProps['sidebarTabs']
  renderToolbar?: DefaultLayoutPluginProps['renderToolbar']
}

interface Props extends Omit<ViewerProps, 'fileUrl'> {
  src: ViewerProps['fileUrl']
  hideBackground?: boolean
  defaultLayout?: DefaultLayoutProps
}

const transparentBackground = css`
  & .rpv-core__inner-page {
    background: transparent;
  }
`

const PdfViewer = memo(function PdfViewer({
  src,
  defaultLayout,
  hideBackground = true,
  plugins,
  ...restOfProps
}: Props) {
  const defaultLayoutOptions = useMemo(() => {
    const { enable, ...options } = defaultLayout || {}
    if (!enable) return undefined

    return options
  }, [defaultLayout])
  const defaultLayoutPlugingInstance = defaultLayoutPlugin(defaultLayoutOptions)

  return (
    <Box
      css={css`
        height: 100%;
        width: 100%;
        ${hideBackground ? transparentBackground : ''};
      `}
    >
      <Viewer
        fileUrl={src}
        plugins={defaultLayout?.enable ? [defaultLayoutPlugingInstance] : plugins}
        {...restOfProps}
      />
    </Box>
  )
})

export default PdfViewer
